import { TemplateRef } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';
import { ScFieldConfig } from './table.model';

export interface ScStepType {
  label: string;
  fields: ScFieldConfig[];
  icon: string;
  options?: FormlyFormOptions;
  actions?: any[];
}

export interface ScStepAction {
  name: string;
  class: string;
  type: string;
}

export class ScStepConfig {
  title: string;
  description: string;
  icon: string;
  route: string;
  formGroupName: string;
}

export class ScStep {
  stepIndex: number;
  route: string;
  form: FormGroup;
  done: boolean;
  config: ScStepConfig;

  constructor(data: ScStep) {
    this.stepIndex = data.stepIndex;
    this.route = data.route;
    this.form = data.form;
    this.done = data.done;
    this.config = data.config;
  }
}

export interface ScContentTemplate {
  isEmpty: boolean;
  template: TemplateRef<any>;
}

export class ScStepper {
  stepCount: number;
  currentStep: ScStep;
  previousStep: ScStep;
  nextStep: ScStep;

  constructor() {}
}
